<template>
    <div class="page-qualification">
        <div class="content-box first"></div>
        <TitleTip>我们需要对合作的公司的资质进行审核，以方便监管部门审视我们的版权合作业务</TitleTip>
        <el-form ref="formData" label-position="top" :model="formData">
            <div class="content-box">
                <div class="title">
                    银行证明信息
                    <span>任意填写一项，鼓励都填写（格式JPG、JPEG、PNG、PDF、Excel，不得大于10M）</span>
                </div>
                <div class="main-form" style="width: 660px;">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="基本存款账号信息">
                                <FileUpload v-model="formData.basicDepositAccountInformation"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                    <template slot="tips">
                                        <el-button @click="dialogUrl = '1.svg'; dialogVisible = true;"
                                            type="text underline">查看示例</el-button>
                                    </template>
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="已开立银行结算账户清单">
                                <FileUpload v-model="formData.bankSettlementAccountList"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                    <template slot="tips">
                                        <el-button @click="dialogUrl = '2.svg'; dialogVisible = true;"
                                            type="text underline">查看示例</el-button>
                                    </template>
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="自填银行信息加盖公章">
                                <FileUpload v-model="formData.bankInformationStampedWithOfficialSeal"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                    <template slot="tips">
                                        <el-button @click="dialogUrl = '3.svg'; dialogVisible = true;"
                                            type="text underline">查看示例</el-button>
                                    </template>
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="content-box">
                <div class="title">
                    财税信息/办公场所证明
                    <span>任意填写一项，鼓励都填写（格式JPG、JPEG、PNG、PDF、Excel，不得大于10M）</span>
                </div>
                <div class="main-form" style="width: 660px;">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="近三个月财务报表">
                                <FileUpload v-model="formData.financialStatements"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="近3个月社保缴费证明材料">
                                <FileUpload v-model="formData.proofOfSocialSecurityPayment"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                    <template slot="tips">如缴费银行回单、社保中心缴费记录</template>
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="公司房屋租赁合同或房产证明">
                                <FileUpload v-model="formData.housingLeaseContractOrPropertyCertificate"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="content-box">
                <div class="title">
                    其他信息
                    <span>任意填写一项，鼓励都填写（格式JPG、JPEG、PNG、PDF、Excel，不得大于10M）</span>
                </div>
                <div class="main-form" style="width: 660px;">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="公司简介">
                                <FileUpload v-model="formData.companyProfile"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="组织架构及人员规模">
                                <FileUpload v-model="formData.organizationalStructureAndPersonnelSize"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="近3个月个税缴纳证明材料">
                                <FileUpload v-model="formData.proofOfIndividualIncomeTaxPayment"
                                    accept="image/png,image/jpeg,image/jpg,application/pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                    <template slot="tips">个税扣费银行回单、税务系统个税纳税证明</template>
                                </FileUpload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="m-t-6" style="text-align: center;">
                <el-button type="info" @click="$router.go(-1);">返回</el-button>
                <el-button type="info" @click="updateSave(0)">暂存</el-button>
                <el-button type="primary" @click="onSubmit">提交材料</el-button>
            </div>
        </el-form>
        <el-dialog title="预览" :visible.sync="dialogVisible" append-to-body width="500px">
            <img style="width: 100%;" :src="`/qualification/${dialogUrl}`" />
        </el-dialog>
    </div>
</template>

<script>
import { getQualification } from '@/api/user';
export default {
    data() {
        return {
            formData: {
                basicDepositAccountInformation: '', // 基本存款信息
                bankSettlementAccountList: '', // 已开立银行结算账户清单
                bankInformationStampedWithOfficialSeal: '', // 自填银行信息加盖公章
                financialStatements: '', // 近三个月财务报表
                proofOfSocialSecurityPayment: '', // 近3个月社保缴费证明材料
                housingLeaseContractOrPropertyCertificate: '', //公司房屋租赁合同或房产证明
                companyProfile: '', // 公司简介
                organizationalStructureAndPersonnelSize: '', // 组织架构及人员规模
                proofOfIndividualIncomeTaxPayment: '' // 个税缴纳证明材料
            },
            dialogVisible: false,
            dialogUrl: ''
        };
    },
    mounted() {
        this.fetchQualification();
    },
    methods: {
        // 获取企业资质
        async fetchQualification() {
            const response = await getQualification();
            const { msg, state, result } = response.data;
            if (!state) return this.$message.error(msg || '');
            this.formData = { ...this.formData, ...result }
        },
        async updateSave(status) {
            const form = JSON.parse(JSON.stringify(this.formData))
            form.status = status;
            const response = await this.$request({
                url: '/cpEnterpriseQualification/saveOrUpdate',
                method: 'POST',
                data: form,
                formData: false
            });
            const { msg, state } = response.data;
            if (!state) return this.$message.error(msg || '');
            this.$message.success(status === 0 ? '暂存成功' : '提交成功');
            this.fetchQualification();
        },
        onSubmit() {
            this.$refs['formData'].validate(async valid => {
                if (!valid) return;
                const {
                    basicDepositAccountInformation,
                    bankSettlementAccountList,
                    bankInformationStampedWithOfficialSeal,
                    financialStatements,
                    proofOfSocialSecurityPayment,
                    housingLeaseContractOrPropertyCertificate,
                    companyProfile,
                    organizationalStructureAndPersonnelSize,
                    proofOfIndividualIncomeTaxPayment
                } = this.formData;
                if (!(basicDepositAccountInformation || bankSettlementAccountList || bankInformationStampedWithOfficialSeal))
                    return this.$message.error('银行证明信息必须填写一项');
                if (!(financialStatements || proofOfSocialSecurityPayment || housingLeaseContractOrPropertyCertificate))
                    return this.$message.error('财税信息/办公场所证明必须填写一项');
                if (!(companyProfile || organizationalStructureAndPersonnelSize || proofOfIndividualIncomeTaxPayment))
                    return this.$message.error('其他信息必须填写一项');
                const flag = await this.$confirm(
                    `提交后，用户在前台无法再提交资质信息，<br/>
                    资料状态变为“已提交”如果后续修改资料，你可以<br/>
                    1. 在后台修改资料，或<br/>
                    2.开启前台修改，用户修改资料后提交`,
                    '保存并提交',
                    {
                        dangerouslyUseHTMLString: true,
                        center: true,
                        confirmButtonText: '保存并提交'
                    }
                ).catch(() => 'cancel');
                if (flag === 'cancel') return;
                this.updateSave(1);
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.page-qualification {
    overflow: hidden;

    .first {
        padding-top: 0px;
        border-radius: 0px;
    }
}
</style>
